import { render } from "./Header.vue?vue&type=template&id=13d55377"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=13d55377&lang=css"

import exportComponent from "/tmp/builds/1syD-sny/0/plataforma/frontend/side_panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__